/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2018 MDL Online (https://mdlonline.nl)
 * @package MDLOnline_base
 */

define(["jquery"], function ($) {
    'use strict';

    $(function () {

        // Toggle visability of filters on mobile
        $('.layered-top-nav .toggle-filter, .block.filter .filter-close, .filter-background').click(function () {
            $('.filter-wrap').toggleClass('hidden visible');
        });

        // Make filter groups collapsible
        $('.block.filter .filter-options-title').click(function () {
            const $clickedOptionTitle = $(this);

            $clickedOptionTitle.next('.filter-options-content').slideToggle(300);
            $clickedOptionTitle.find('i[class*="fa-"]').toggleClass('fa-minus fa-plus');
        });

        // Add show/more less toggle to long filter lists
        $('.block.filter .item-more-less').click(function () {
            const $clickedMoreLessLink = $(this);

            $clickedMoreLessLink.siblings('.item.hidden').slideToggle(300);
            $clickedMoreLessLink.find('.option').toggle();
        });

        // Make the whole active filter clickable on mobile
        $('.layered-top-nav .filter-current .item').click(function () {
            $(this).children('.action.remove').trigger('click');
        });
    });
});
